import { SelectProps, PropertyFilterProps } from "@amzn/awsui-components-react";
import { getString } from "common/ui-string-labels/ui-strings-utils";
import { VENDORS } from "configuration/config";

export interface BulkOrderSource {
    vendor: string;
    taxonomyId: string;
    productTaxonomy: string;
    softwareName: string;
    sku: string;
    type: "STANDARD" | "PORTAL";
    quantity?: number;
    cost?: number;
    costCenter?: string;
    isActive: boolean;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
}

export const EMPTY_ROW: Record<string, any> = {
    softwareName: "",
    sku: "",
    vendor: "",
    type: "STANDARD",
    quantity: null,
    cost: null,
    costCenter: null,
};

/** Vendors selectable when creating a bulk order template. User-selected, never derived from the SKU. */
export const BULK_VENDOR_OPTIONS: string[] = VENDORS.filter(v => v.isBulkVendor).map(v => v.id);

export const VENDOR_OPTIONS: SelectProps.Option[] = [
    { label: getString("bulkOrders.filters.allVendors"), value: "" },
    ...VENDORS.filter(v => v.isBulkVendor).map(v => ({ label: v.label, value: v.skuPrefix })),
];

export const STATUS_OPTIONS: SelectProps.Option[] = [
    { label: getString("bulkOrders.filters.active"), value: "true" },
    { label: getString("bulkOrders.filters.inactive"), value: "false" },
    { label: getString("bulkOrders.filters.all"), value: "" },
];

export const FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
    { key: "softwareName", propertyLabel: getString("bulkOrders.columns.software"), groupValuesLabel: getString("bulkOrders.columns.software"), operators: ["="] },
    { key: "sku", propertyLabel: getString("bulkOrders.columns.partNumber"), groupValuesLabel: getString("bulkOrders.columns.partNumber"), operators: ["="] },
];
